export default {
  props: {
    username: {
      label: '用户名',
    },
    display: {
      label: '显示名',
    },
    _roles: {
      label: '角色',
    },
    enabled: {
      label: '启用',
      formatter(e) { return e ? '' : '已禁用' },
    },
    note: {
      label: '备注',
      maxlength: 15,
      classes: 'collapsing hide-in-mobile',
    },
  },
  actions: {
    edit: {
      icon: 'pencil',
      tooltip: '编辑',
    },
  },
  layouts: {
    default: {
      layout: [
        'enabled',
        'username',
        'display',
        '_roles',
        'note',
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./client/src/defines/user.js